<template>
  <div class="pb-2">
    <gameAutoComplete :place="schema.placeholder" v-on:selected="setValue" />

    <div class="users-list-w">
      <div class="user-w with-status" v-if="selected" v-for="selectedFrom in selected">
        <div class="user-name">
          <div class="item-media" :style="'background-image: url('+selectedFrom.thumbnail+')'"></div>
          <div class="item-name">{{ selectedFrom.name | slimiter(24) }}
          </div>
        </div>
        <a class="user-action" href="javascript:;">
          <div v-on:click="remove(selectedFrom.id)" class="os-icon os-icon-cancel-circle"></div>
        </a>
      </div>
    </div>
    <input
      class="form-control"
      type="hidden"
      v-model="value"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly" >
  </div>
</template>

<script>
  import gameAutoComplete from '@/components/autocomplete/gameAutoComplete'
  import { abstractField } from "vue-form-generator";

  export default {
    name: 'vfg-field-games',
    components: { gameAutoComplete },
    mixins: [ abstractField ],
    data () {
      return {
        t: this.$root.t,
        result: null,
        selected: [],
        q: '',
      }
    },
    watch: {
      'selected' (o, n) {
        /*
        if (this.schema.multi && n) {
            this.value = [];
            if (this.schema.onlyId) {

              this.selected.forEach((val) => {
                    if(!findByKeyAndRemove(this.value, 'id', n.id))
                        this.value.push(val.id);
                });

            }else {
                this.value = this.selected;
            }
        }
        */
      }
    },
    mounted () {
      if (this.schema.data) {
        this.selected = this.schema.data;
      }else {
        this.value = [];
        this.selected = [];
      }
    },
    methods: {

      clear () {
        if(!this.q) {
          this.result = null;
          this.value = [];
        }
      },
      remove (item) {
        this.findByKeyAndRemove(this.selected, 'id', item);
        this.findByKeyAndRemove(this.value, 'id', item);
      },
      setValue (val, tit) {
        if(val) {
          if (this.schema.multi) {
            if (this.schema.onlyId) {
              this.value.push(val.id);
            }else  {
              this.value.push(val);
            }

            this.selected.push(val);
          }else {
            this.selected = [];
            this.value = val.id;
            this.selected.push(val);
          }

          this.q = tit;
          this.result = null;
        }else {
          this.result = null;
          this.value = [];
        }

      },
      search (q) {

        this.$http.get(bsapi+'api/v1/search/casino/'+this.q).then(response => {
          // get body data
          this.result = (q) ? response.body.result : null;
          this.value = [];
        }, response => {
          this.value = [];
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .list-group {
    background: #fff;
    list-style: none
  }
  .list-group .list-group-item{
    border-bottom: 1px solid #ccc;
    padding: 0px 5px 0px 5px;

  }
</style>



// WEBPACK FOOTER //
// src/components/form/fieldGames.vue